export var selectDefaultProps = {
  className: "",
  customComponents: null,
  hasError: false,
  isAsync: false,
  isMenuVisibleOnFocus: false,
  isCreatable: false,
  isMulti: false,
  informationCell: null,
  linkCell: null,
  placeholder: "",
  options: [],
  noInteractionBorder: false
};